<template>
  <div class="layout-content-list">
    <el-breadcrumb separator="/" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>物流圈</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>全部车辆列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">司机状态</span>
        <el-select v-model="filter.driverState" placeholder="请选择" style="width: 148px">
          <el-option v-for="item in driverStatusList" :label="item.name" :value="item.val" :key="item.val"> </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">筛选条件</span>
        <el-select v-model="filter.chooseType" placeholder="请选择" style="width: 148px">
          <el-option v-for="item in chooseTypeList" :label="item.name" :value="item.val" :key="item.val"> </el-option>
        </el-select>
        <el-input
          v-model.trim="filter.keyword"
          style="width: 240px"
          :maxlength="ordernumberKeywordLimit"
          placeholder="请输入关键字"
        ></el-input>
      </div>
      <div class="toolbar-item" id="auto-2">
        <el-button type="primary" size="small" @click="search">筛选</el-button>
      </div>
    </div>
    <div class="table-custom-box mt-10" id="auto-3">
      <el-table :data="tableData.data" border>
        <el-table-column prop="driverName" label="司机" width="180"> </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" width="180"> </el-table-column>
        <el-table-column prop="driverPhone" label="手机号" width="180"> </el-table-column>
        <el-table-column prop="pullCount" label="拉运次数" width="180"> </el-table-column>
        <el-table-column prop="lastOrderTime" label="最近接单日期" width="180"> </el-table-column>
        <el-table-column prop="driverStateDesc" label="司机状态"> </el-table-column>
        <el-table-column label="操作" width="140">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="handleClick(scope.row)">查看位置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:3
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axiosNew from '@/api/axiosNew';
import api from '@/api/logistics.api';
import { WUYI, vali } from '@/api/common';
import eventIdMap from '@/views/logistics/eventIdMap';
export default {
  data: function () {
    return {
      currentPage: 1,
      pageSize: 20,
      companyCode: WUYI.currentData.company.companycode,
      filter: {
        driverState: 0, // 司机状态
        chooseType: 1, // 筛选条件
        keyword: '' // 筛选内容
      },
      chooseTypeList: [
        { name: '车牌号', val: 1 },
        { name: '手机号', val: 3 },
        { name: '姓名', val: 2 }
      ],
      driverStatusList: [
        { name: '全部', val: 0 },
        { name: '空闲', val: 1 },
        { name: '在途-本企业', val: 2 },
        { name: '在途-其他企业', val: 3 }
      ],
      tableData: {
        total: 0,
        data: []
      },
      cache: {}
    };
  },
  created() {
    this[eventIdMap.eventAction]({
      ctp: window.location.href,
      eventId: eventIdMap.allCarListPage.id,
      event: eventIdMap.allCarListPage.dec,
      logType: eventIdMap.pageEventType
    });
    this.search();
  },
  methods: {
    search() {
      this.cache = { ...this.filter };
      this.currentPage = 1;
      this.featchData();
    },
    featchData() {
      const options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        companyCode: this.companyCode,
        ...this.cache
      };
      axiosNew.post(api.vehicleListAll, options).then(res => {
        this.tableData = res.data;
      });
    },
    //分页点击
    handleCurrentChange: function (val) {
      this.currentPage = val;
      this.featchData();
    },
    handleClick(item) {
      this[eventIdMap.eventAction]({
        ctp: window.location.href,
        eventId: eventIdMap.allCarListShowTrackBtn.id,
        event: eventIdMap.allCarListShowTrackBtn.dec,
        logType: eventIdMap.btnEventType
      });

      // 在途-本企业 跳转到轨迹详情,其他状态跳转到当前位置
      if (item.driverState == 2) {
        axiosNew
          .post(api.driverTrack, { driverCode: item.driverCode, companyCode: this.companyCode }, { silence: true })
          .then(res => {
            this.$router.push({
              path: `/orderDtlMap/${res.data.orderNumber}`
            });
          });
      } else {
        this.$router.push({
          path: `/driverCurrentLocation/${item.driverCode}`
        });
      }
    }
  }
};
</script>
